import { useGetAllocationRequestRows } from '../../pages/registry/allocationRequest/useGetAllocationRequestRows';
import { useInboundBurnRequests } from './useInboundBurnRequests';
import { useInboundCommercialAgreementRequests } from './useInboundCommercialAgreementRequests';
import { useInboundCredentialOffers } from './useInboundCredentialOffers';
import { useInboundMintRequests } from './useInboundMintRequests';
import { useInboundProviderServiceRequests } from './useInboundProviderServiceRequests';
import { useInboundRegistrarServiceRequests } from './useInboundRegistrarServiceRequests';
import { useInboundTransferInstructions } from './useInboundTransferInstructions';

export const useInboundSummary = () => {
  const transfers = useInboundTransferInstructions();
  const allocations = useGetAllocationRequestRows();
  const burns = useInboundBurnRequests();
  const mints = useInboundMintRequests();
  const registrars = useInboundRegistrarServiceRequests();
  const providers = useInboundProviderServiceRequests();
  const credentials = useInboundCredentialOffers();
  const csa = useInboundCommercialAgreementRequests();

  const isLoading = [
    transfers,
    allocations,
    burns,
    mints,
    registrars,
    providers,
    credentials,
    csa,
  ].some((q) => q.isLoading);
  const counts = {
    transfers: transfers.data ?? 0,
    allocations: allocations.rows.length ?? 0,
    burns: burns.data ?? 0,
    mints: mints.data ?? 0,
    registrars: registrars.data ?? 0,
    providers: providers.data ?? 0,
    credentials: credentials.data ?? 0,
    csa: csa.data ?? 0,
  };
  const totalInbound = Object.values(counts).reduce((acc, curr) => acc + Number(curr), 0);
  return {
    isLoading,
    counts,
    totalInbound,
  };
};
